interface VaultMarkProps {
  compact?: boolean;
}

export function VaultMark({ compact = false }: VaultMarkProps) {
  return (
    <div className={compact ? "vault-mark vault-mark--compact" : "vault-mark"} aria-hidden="true">
      <span className="vault-mark__shackle" />
      <span className="vault-mark__body">
        <span className="vault-mark__keyhole" />
      </span>
    </div>
  );
}
